/**
 * Ship / pickup choice in the cart drawer and cart page.
 * Pickup hides Route shipping protection (see delivery-choice.css) and shows a
 * checkout button that removes any Route item before going to checkout.
 */
const DELIVERY_CHOICE_STORAGE_KEY = 'delivery-choice';

function readDeliveryChoice() {
  try {
    return sessionStorage.getItem(DELIVERY_CHOICE_STORAGE_KEY) === 'pickup' ? 'pickup' : 'ship';
  } catch (error) {
    return 'ship';
  }
}

function saveDeliveryChoice(choice) {
  try {
    sessionStorage.setItem(DELIVERY_CHOICE_STORAGE_KEY, choice);
  } catch (error) {
    // Storage can be blocked; the choice still applies until the page reloads.
  }
}

document.documentElement.dataset.deliveryChoice = readDeliveryChoice();

class DeliveryChoice extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', this.onChange.bind(this));
  }

  connectedCallback() {
    this.sync();
  }

  sync() {
    const choice = document.documentElement.dataset.deliveryChoice;
    this.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.checked = input.value === choice;
    });
  }

  onChange(event) {
    const choice = event.target.value === 'pickup' ? 'pickup' : 'ship';
    saveDeliveryChoice(choice);
    document.documentElement.dataset.deliveryChoice = choice;
    document.querySelectorAll('delivery-choice').forEach((element) => element.sync());
  }
}
customElements.define('delivery-choice', DeliveryChoice);

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-pickup-checkout]');
  if (!button) return;

  event.preventDefault();
  button.disabled = true;

  // Route's own "without coverage" button sets this so its script ignores the cart update.
  window.routeSkipInterception = true;
  try {
    const cart = await fetch(`${FoxTheme.routes.cart_url}.js`).then((response) => response.json());
    const updates = {};
    cart.items.forEach((item) => {
      if (item.vendor === 'Route') updates[item.key] = 0;
    });
    const body = JSON.stringify({ updates, attributes: { route_toggle_state: 0 } });
    await fetch(`${FoxTheme.routes.cart_update_url}`, { ...FoxTheme.utils.fetchConfig(), ...{ body } });
  } catch (error) {
    console.error(error);
  } finally {
    window.location.href = `${window.Shopify?.routes?.root || '/'}checkout`;
  }
});
